import React, { useState, useEffect } from 'react';
import styles from './LoadingCircle.module.css';

const LoadingCircle = ({ isSearching }) => {
  const [progress, setProgress] = useState(0); 

  useEffect(() => {
    const timer = setInterval(() => {
      if (progress < 100 && isSearching) {
        setProgress(prevProgress => prevProgress + 1);
      }
    }, 680); 

    return () => clearInterval(timer);
  }, [progress, isSearching]); 

  return (
    <>
      {isSearching && (
        <div className={styles.circle}>
          <span className={styles.percentage}>{progress}%</span>
          <svg viewBox="0 0 100 100" className={styles.svg}>
            <circle cx="50" cy="50" r="45" className={styles.background} />
            <circle cx="50" cy="50" r="45" className={styles.stroke} style={{ strokeDasharray: `${progress * 2.83}, 283` }} />
          </svg>
        </div>
      )}
    </>
  );
};

export default LoadingCircle;
